var createListItem = function (result) {
    var template = '<div class="search-dropdown__item">\
        <a href="' + result.collection_handle + '" class="search-result search-result--store-link">\
            <div class="search-result__title search-result__store-name">' + result.store_name + '</div>\
            <div class="search-result__meta search-result__school-name">' + result.school.name + ' - ' + result.school.city + ', ' + result.school.province + ', ' + result.school.country + '</div>\
        </a>\
    </div>';

    return template;
}

var StoreSearch = function (element) {
    var $element = $('#' + element);
    var $window = $(window);
    var $schoolFilters = '';
    this.xhr = null;

    if ($window.width() > 1024) {
        $schoolFilters = $element.find('.input-group select.search-by--large');
    } else {
        $schoolFilters = $element.find('.input-group select.search-by--small');
    }

    this.cache = {
        $form: $element,
        $element: $element.find('input[type="text"]').first(),
        $wrapper: $element,
        $resultList: null,
        searchTerm: $element.val(),
        $schoolFilters: $schoolFilters,
        selectedFilter: null,
        results: []
    }

    this.init();
    this.eventListeners();
}

StoreSearch.prototype.init = function () {
    this.cache.$wrapper.css('position', 'relative');
    this.cache.selectedFilter = this.cache.$schoolFilters.val();
}

StoreSearch.prototype.eventListeners = function () {
    this.cache.$element.on('keyup', function (event) {
        var term = event.target.value;
        this.cache.searchTerm = term;
        this.cache.selectedFilter = this.cache.$schoolFilters.val();
        this.search();
    }.bind(this));

    this.cache.$schoolFilters.on('change', function (event) {
        this.cache.selectedFilter = event.target.value;
        this.search();
    }.bind(this));

    this.cache.$form.on('submit', function (event) {
        event.preventDefault();

        var term = $(event.target).find('input[type="text"]').first().val();
        this.cache.searchTerm = term;
        this.cache.selectedFilter = this.cache.$schoolFilters.val();
        this.search();
    }.bind(this));
}

StoreSearch.prototype.search = function () {
    if (this.xhr) {
        this.xhr.abort();
    }

    this.xhr = $.ajax({
        type: 'post',
        crossDomain: true,
//         url: api_url + '/api/v1/school/search',
      	url: api_url + '/api/v1/school/intl_search',
        dataType: 'json',
        data: {
          query: this.cache.searchTerm
//             search: {
//                 filterable_col: this.cache.selectedFilter == 'school' ? 'schools.name' : 'representatives.store_name',
//                 filterable_val: this.cache.searchTerm,
//                 filter_by: this.cache.selectedFilter == 'school' ? 'school_name' : 'store_name'
//             }
          
        },
        success: function (response) {
            this.cache.results = response.data;
            this.showResults();
        }.bind(this)
    })
}

StoreSearch.prototype.showResults = function () {
    if (this.cache.searchTerm.length) {
        if (!this.cache.$resultList) {
            var $resultList = $('<div class="search-dropdown__content"></div>');
            this.cache.$resultList = $resultList;
            $resultList.appendTo(this.cache.$form.find('.search-dropdown__scroller'));
        }
        this.cache.$resultList.empty();
        for (var i = 0; i < this.cache.results.length; i++) {
            var result = this.cache.results[i];
            this.cache.$resultList.append(createListItem(result));
        }
        this.bindStoreLinks();

        this.cache.$element[0].dispatchEvent(new CustomEvent('postSearch'));
    } else {
        if (this.cache.$resultList) {
            this.cache.$resultList.remove();
            this.cache.$resultList = null;
        }
    }
}

StoreSearch.prototype.bindStoreLinks = function () {
    this.cache.$resultList.on('click', function (event) {
        event.preventDefault();
        var $element = $(event.target).hasClass('search-result--store-link') ? $(event.target) : $(event.target).parents('.search-result--store-link');
        var store_name = $element.find('.search-result__store-name').text();
        var school_name = $element.find('.search-result__school-name').text();
        var url = $element.attr('href');
        $.ajax({
            url: '/cart/update.js',
            type: 'post',
            dataType: 'json',
            data: {
                attributes: {
                    store_name: store_name,
                    school_name: school_name
                }
            },
            success: function () {
                location.href = url;
            }.bind(this)
        });
    });
}